import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';

import { RouterModule } from '@angular/router';

// Ng Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Forms
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

// Other Modules
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FontAwesome } from '../font-awesome/font-awesome.module';
import { NgChartsModule } from 'ng2-charts';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClipboardModule } from 'ngx-clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';

// My Modules/Components
import { LoadingSpinnerComponent } from '../../components/shared/loading-spinner/loading-spinner.component';

import { PagingSearchBarComponent } from '../../components/shared/paging-search-bar/paging-search-bar.component';
import { PagingBarComponent } from '../../components/shared/paging-bar/paging-bar.component';
import { ColumnHeadingsComponent } from '../../components/shared/column-headings/column-headings.component';

import { TableLogsComponent } from '../../components/shared/table-logs/table-logs.component';
import { TableJournalsComponent } from '../../components/shared/table-journals/table-journals.component';
import { TableLoginsComponent } from '../../components/shared/table-logins/table-logins.component';
import { TableDownloadsComponent } from '../../components/shared/table-downloads/table-downloads.component';
import { TableClicksComponent } from '../../components/shared/table-clicks/table-clicks.component';
import { TableNotificationsComponent } from '../../components/shared/table-notifications/table-notifications.component';
import { TableDownloadableBuildsComponent } from '../../components/shared/table-downloadable-builds/table-downloadable-builds.component';
import { TableDownloadableDocumentsComponent } from '../../components/shared/table-downloadable-documents/table-downloadable-documents.component';
import { TableUsersComponent } from '../../components/shared/table-users/table-users.component';
import { TableNotificationUsersComponent } from '../../components/shared/table-notification-users/table-notification-users.component';
import { TableOrganizationsComponent } from '../../components/shared/table-organizations/table-organizations.component';
import { TableKeysComponent } from '../../components/shared/table-keys/table-keys.component';
import { TableBuildsComponent } from '../../components/shared/table-builds/table-builds.component';
import { TableDocumentsComponent } from '../../components/shared/table-documents/table-documents.component';
import { TableLicensesComponent } from '../../components/shared/table-licenses/table-licenses.component';
import { TableMarketplaceLogsComponent } from '../../components/shared/table-marketplace-logs/table-marketplace-logs.component';
import { TableZenUsersComponent } from '../../components/shared/table-zen-users/table-zen-users.component';
import { TableZensComponent } from '../../components/shared/table-zens/table-zens.component';
import { TableBillingCodesComponent } from '../../components/shared/table-billing-codes/table-billing-codes.component';

import { KeyInfoComponent } from '../../components/shared/key-info/key-info.component';
import { KeyFeaturesComponent } from '../../components/shared/key-features/key-features.component';
import { KeyMetersComponent } from '../../components/shared/key-meters/key-meters.component';

import { PopupBoxComponent } from '../../components/shared/popup-box/popup-box.component';

import { CardKeyComponent } from '../../components/shared/card-key/card-key.component';
import { CardLicenseComponent } from '../../components/shared/card-license/card-license.component';
import { CardUserComponent } from '../../components/shared/card-user/card-user.component';
import { CardOrganizationComponent } from '../../components/shared/card-organization/card-organization.component';
import { CardZenMasterComponent } from '../../components/shared/card-zen-master/card-zen-master.component';
import { CardPartnershipComponent } from '../../components/shared/card-partnership/card-partnership.component';
import { CardBuildDownloadComponent } from '../../components/shared/card-build-download/card-build-download.component';
import { CardDocumentDownloadComponent } from '../../components/shared/card-document-download/card-document-download.component';
import { CardBillingCodeComponent } from '../../components/shared/card-billing-code/card-billing-code.component';
import { CardProtocolSetComponent } from '../../components/shared/card-protocol-set/card-protocol-set.component';
import { CardKeyTemplateComponent } from '../../components/shared/card-key-template/card-key-template.component';
import { CardKeyProductComponent } from '../../components/shared/card-key-product/card-key-product.component';
import { CardBuildComponent } from '../../components/shared/card-build/card-build.component';
import { CardDocumentComponent } from '../../components/shared/card-document/card-document.component';
import { CardFileComponent } from '../../components/shared/card-file/card-file.component';

// Pipes
import { BytesPipe } from 'client/app/pipes/bytes.pipe';
import { AmpPipe } from 'client/app/pipes/amp.pipe';
import { TimeBackPipe } from 'client/app/pipes/time-back';
import { AcronymPipe } from 'client/app/pipes/acronym';

@NgModule({
	declarations: [
		LoadingSpinnerComponent,
		PagingSearchBarComponent,
		PagingBarComponent,
		ColumnHeadingsComponent,

		TableLogsComponent,
		TableJournalsComponent,
		TableLoginsComponent,
		TableDownloadsComponent,
		TableClicksComponent,
		TableNotificationsComponent,
		TableDownloadableBuildsComponent,
		TableDownloadableDocumentsComponent,
		TableUsersComponent,
		TableNotificationUsersComponent,
		TableOrganizationsComponent,
		TableKeysComponent,
		TableBuildsComponent,
		TableDocumentsComponent,
		TableLicensesComponent,
		TableMarketplaceLogsComponent,
		TableZenUsersComponent,
		TableZensComponent,
		TableBillingCodesComponent,

		KeyInfoComponent,
		KeyFeaturesComponent,
		KeyMetersComponent,

		PopupBoxComponent,

		CardKeyComponent,
		CardLicenseComponent,
		CardUserComponent,
		CardOrganizationComponent,
		CardZenMasterComponent,
		CardPartnershipComponent,
		CardBuildDownloadComponent,
		CardDocumentDownloadComponent,
		CardBillingCodeComponent,
		CardProtocolSetComponent,
		CardKeyTemplateComponent,
		CardKeyProductComponent,
		CardBuildComponent,
		CardDocumentComponent,
		CardFileComponent,

		BytesPipe,
		AmpPipe,
		TimeBackPipe,
		AcronymPipe
	],
	imports: [
		CommonModule,
		NgbModule,
		FormsModule,
		ReactiveFormsModule,
		FontAwesomeModule,
		NgSelectModule,
		ClipboardModule,
		FontAwesome,
		DragDropModule,
		NgChartsModule,
		RouterModule
	],
	exports: [
		LoadingSpinnerComponent,
		PagingSearchBarComponent,
		PagingBarComponent,
		ColumnHeadingsComponent,

		TableLogsComponent,
		TableJournalsComponent,
		TableLoginsComponent,
		TableDownloadsComponent,
		TableClicksComponent,
		TableNotificationsComponent,
		TableDownloadableBuildsComponent,
		TableDownloadableDocumentsComponent,
		TableUsersComponent,
		TableNotificationUsersComponent,
		TableOrganizationsComponent,
		TableKeysComponent,
		TableBuildsComponent,
		TableDocumentsComponent,
		TableLicensesComponent,
		TableMarketplaceLogsComponent,
		TableZenUsersComponent,
		TableZensComponent,
		TableBillingCodesComponent,

		KeyInfoComponent,
		KeyFeaturesComponent,
		KeyMetersComponent,
		PopupBoxComponent,

		CardKeyComponent,
		CardLicenseComponent,
		CardUserComponent,
		CardOrganizationComponent,
		CardZenMasterComponent,
		CardPartnershipComponent,
		CardBuildDownloadComponent,
		CardDocumentDownloadComponent,
		CardBillingCodeComponent,
		CardProtocolSetComponent,
		CardKeyTemplateComponent,
		CardKeyProductComponent,
		CardBuildComponent,
		CardDocumentComponent,
		CardFileComponent,

		CommonModule,
		DecimalPipe,
		BytesPipe,
		AmpPipe,
		TimeBackPipe,
		AcronymPipe
	],
	providers: [
		DecimalPipe,
		BytesPipe,
		AmpPipe,
		TimeBackPipe,
		AcronymPipe
	]
})

export class SharedModule { }
